export const GET_ALERTS = 'toasts/GET_ALERTS'
export const NEW_TOASTS = 'toasts/NEW_TOASTS'
export const NEW_TOAST = 'toasts/NEW_TOAST'
export const CLOSE_TOAST = 'toasts/CLOSE_TOAST'
export const RESET = 'toasts/RESET'

export const newToasts = toasts => ({
  type: NEW_TOASTS,
  toasts: toasts.map(toast => ({
    ...toast,
    id: toast.id ?? Math.random().toString(16).substring(2)
  }))
})

export const closeToast = id => ({
  type: CLOSE_TOAST,
  id
})

export const newToast = toast => ({
  type: NEW_TOAST,
  toast: {
    ...toast,
    id: toast.id ?? Math.random().toString(16).substring(2)
  }
})

export const reset = () => ({
  type: RESET
})
